/* eslint-disable max-len */
import React from 'react'

const ImageUpload = ({handleUploadChange,id}) => {
    return (
        <div className='border-2 border-dashed  border-[#972E4C] relative rounded-[9px]'>
            <div className='flex justify-center lg:h-[140px]  xl:h-[180px]  flex-col items-center relative'>
                <div class="w-[120px] h-fit rounded-md border-[#A1A1A9] mt-2 flex justify-center items-center relative">
                    <div className='bg-[#EDD7E1] py-[16px] px-[36px] mb-[20px] rounded-[50px] hover:bg-[#D296B2] '>
                    
                        <img src={"/images/octicon_upload-16.svg"} alt="icon" className='fileupload-input  cursor-pointer   mx-auto' />
                        <input
                            type="file" 
                            id={id}
                            data-test="file"
                            title=""
                            onFocus={()=>{}}
                            accept="image/jpeg, image/png, application/pdf" 
                            onChange={(e)=>handleUploadChange(e)}
                            className="opacity-0 absolute top-0 left-0 text-[0px] w-[120px] h-[55px] cursor-pointer z-10"
                        />
              
                    </div>
                </div>
                <p className='text-[12px] font-normal text-[#000000] xl:mb-[20px] mb-[10px] text-center'>Click here to upload</p>
            </div>
            <div className='xl:pb-10 pb-5 px-4'>
                <li
                    className='text-[12px] font-normal text-[#52555D]'>Image must be in PNG/JPEG format
                </li>
                <li
                    className='text-[12px] font-normal text-[#52555D]'>Image size cannot exceed 10 MB
                </li>
            </div>
        </div>
    )
}


export default ImageUpload